let googleTrackingIds = [];
let googleTrackingId = null;

function parseTrackingIds(trackingId) {
    if (!trackingId) return [];
    const list = Array.isArray(trackingId) ? trackingId : [trackingId];
    return list
        .flatMap(item => (typeof item === 'string' ? item.split(',') : [item]))
        .map(id => (id ? String(id).trim() : ''))
        .filter(Boolean);
}

export function gtagInit(trackingId) {
    const ids = parseTrackingIds(trackingId);
    if (!ids.length) return;

    googleTrackingIds = ids;
    googleTrackingId = ids[0];

    // 1) dataLayer + gtag function
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };

    // 2) SET DEFAULT CONSENT *BEFORE* any config/events
    // Include CMv2 keys: ad_user_data, ad_personalization
    window.gtag('consent', 'default', {
        ad_storage: 'denied',
        analytics_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        wait_for_update: 500
    });

    // 3) Load the library (can be after default; dataLayer queues until it loads)
    if (!document.getElementById('gtag-js')) {
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${ids[0]}`;
        script.id = 'gtag-js';
        document.head.appendChild(script);
    }

    // 4) Now safe to mark js time and configure the property
    window.gtag('js', new Date());
    ids.forEach(id => {
        window.gtag('config', id, { anonymize_ip: true });
    });
}

export function grantGtagConsent() {
    if (!window.gtag) return;
    window.gtag('consent', 'update', {
        ad_storage: 'granted',
        analytics_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted'
    });
}

// Track an order event (supports Google Enhanced Conversions)
export function gtagOrder(orderParams = {}, userData = null) {
    if (!googleTrackingIds.length) {
        console.warn('gtagOrder: trackingId is not initialized.');
        return;
    }

    if (userData && window.gtag) {
        const enhancedData = {};
        if (userData.email) {
            enhancedData.email = userData.email.trim().toLowerCase();
        }
        if (userData.phone) {
            let phone = String(userData.phone).trim().replace(/\s+/g, '');
            if (phone.startsWith('08') || phone.startsWith('09') || phone.startsWith('02')) {
                phone = '+359' + phone.substring(1);
            } else if (!phone.startsWith('+')) {
                phone = '+' + phone;
            }
            enhancedData.phone_number = phone;
        }
        if (userData.firstName) {
            enhancedData.address = enhancedData.address || {};
            enhancedData.address.first_name = userData.firstName.trim();
        }
        if (userData.lastName) {
            enhancedData.address = enhancedData.address || {};
            enhancedData.address.last_name = userData.lastName.trim();
        }
        if (Object.keys(enhancedData).length > 0) {
            window.gtag('set', 'user_data', enhancedData);
        }
    }

    googleTrackingIds.forEach(id => {
        if (id.startsWith('AW-')) {
            gtagEvent('conversion', {
                send_to: `${id}/uhppCMbG9NYaEKTfksA_`,
                ...orderParams
            });
        } else {
            gtagEvent('purchase', {
                send_to: id,
                ...orderParams
            });
        }
    });
}

// Track a custom event
export function gtagEvent(eventName, eventParams = {}) {
    if (!window.gtag) return;
    window.gtag('event', eventName, eventParams);
}

// Set user properties
export function gtagSetUserProperties(properties = {}) {
    if (!window.gtag) return;
    window.gtag('set', 'user_properties', properties);
}

// Configure additional tracking IDs
export function gtagConfig(trackingId, config = {}) {
    if (!window.gtag) return;
    const ids = parseTrackingIds(trackingId);
    ids.forEach(id => {
        if (!googleTrackingIds.includes(id)) {
            googleTrackingIds.push(id);
        }
        window.gtag('config', id, config);
    });
}

// Track a virtual page view event (for SPA route transitions)
export function gtagPageView(pagePath, pageTitle) {
    if (typeof window === 'undefined' || !window.gtag) return;

    const title = pageTitle || document.title;
    const path = pagePath || (window.location.pathname + window.location.search);
    const location = window.location.href;

    window.gtag('event', 'page_view', {
        page_title: title,
        page_location: location,
        page_path: path
    });

    googleTrackingIds.forEach(id => {
        window.gtag('config', id, {
            page_title: title,
            page_path: path
        });
    });
}

